function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeathv2 = function SvgDeathv2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_-outline-expand",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "44,62 32,62 32,2 46,2 53,17 ",
    style: {
      fill: "#3A4249"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34,62 14,62 5,17 12,2 36,2 43,17 ",
    style: {
      fill: "#62C4C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,22.999H15v-6c0-4.963,4.037-9,9-9s9,4.037,9,9V22.999z M17,20.999h14v-4c0-3.859-3.141-7-7-7  s-7,3.141-7,7V20.999z",
    style: {
      fill: "#3A4249"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 17,
    y: 21.999
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 21,
    y: 21.999
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 25,
    y: 21.999
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 29,
    y: 21.999
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.293,16.706 25,15.413 25,12.999 27,12.999 27,14.585 27.707,15.292 ",
    style: {
      fill: "#3A4249"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.707,16.706 20.293,15.292 21,14.585 21,12.999 23,12.999 23,15.413 ",
    style: {
      fill: "#3A4249"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,29.999h-8c-2.206,0-4-1.794-4-4h2c0,1.103,0.897,2,2,2h8c1.103,0,2-0.897,2-2h2  C32,28.205,30.206,29.999,28,29.999z",
    style: {
      fill: "#3A4249"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,48c0,7.732-6.268,14-14,14c-7.732,0-14-6.268-14-14s6.268-14,14-14C53.732,34,60,40.267,60,48  L60,48z",
    style: {
      fill: "#E0C494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.999,48c0,6.627-5.372,12-12,12c-6.627,0-12-5.372-12-12s5.372-12,12-12  C52.627,36,57.999,41.372,57.999,48L57.999,48z",
    style: {
      fill: "#F2DAAE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EFBC2E"
    },
    width: 2,
    x: 45,
    y: 38.999
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    width: 4,
    x: 44,
    y: 37.999
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.5 -0.866 0.866 0.5 -18.5687 56.8351)",
    width: 2,
    x: 38.938,
    y: 42.499
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -18.5672 54.8422)",
    width: 4.001,
    x: 36.206,
    y: 42.499
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -20.3966 26.863)",
    width: 4,
    x: 37.938,
    y: 50.499
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.001,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -21.1284 26.1311)",
    width: 2,
    x: 37.206,
    y: 50.499
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EFBC2E"
    },
    width: 2,
    x: 45,
    y: 52.999
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    width: 4,
    x: 44,
    y: 55.999
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.5 -0.866 0.866 0.5 -18.569 70.8345)",
    width: 2,
    x: 51.062,
    y: 49.499
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -18.5675 72.8436)",
    width: 4.001,
    x: 51.794,
    y: 51.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -15.2734 31.9865)",
    width: 4,
    x: 50.062,
    y: 43.499
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.001,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -14.542 32.7185)",
    width: 2,
    x: 52.794,
    y: 41.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,48c0,3.313-2.687,6-6,6c-3.313,0-6-2.687-6-6s2.687-6,6-6C49.313,42,52,44.687,52,48L52,48z",
    style: {
      fill: "#AA494A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.999,48c0,2.208-1.791,4-4,4c-2.208,0-4-1.791-4-4s1.791-4,4-4C48.208,44,49.999,45.791,49.999,48  L49.999,48z",
    style: {
      fill: "#D36767"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 24,
    y: 55.999
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 20,
    y: 55.999
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 16,
    y: 55.999
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeathv2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/deathv2.3dfa5f4c.svg";
export { ForwardRef as ReactComponent };